import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const router = new Router({

  routes: [

    {
      path: "/",
      name: "dashboard",
      component: () => import("./pages/dashboard.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Dashboard",
        requiresAuth: true,
      },
    },
    {
      path: "/organization/register",
      name: "register",
      component: () => import("./pages/register.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "register",
        guest: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./pages/login.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Login",
        guest: true,
      },
    },
    {
      path: "/change-password",
      name: "changePassword",
      component: () => import("./pages/changePassword.vue"),
      meta: {
        requiresChangedPassword: false,
        title: "Change Password",
        requiresAuth: false,
      },
    },



    {
      path: "/trial",
      name: "trial",
      component: () => import("./pages/trial.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "trial",
        guest: true,
      },
    },

    {
      path: "/company/:type",
      name: "company",
      component: () => import("./pages/company.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Company",
        requiresAuth: true,
      },
    },
    {
      path: "/employees/:type",
      name: "employees",
      component: () => import("./pages/employees.vue"),
      // props: (route) => ({ user: JSON.parse(route.params?.user) }),
      meta: {
        requiresChangedPassword: true,
        title: "employees",
        requiresAuth: true,
      },
    },

    {
      path: "/timeoff-setups/time-off-journals/:type",
      name: "journals",
      component: () => import("./pages/journal.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "journals",
        requiresAuth: true,
      },
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("./pages/profile.vue"),
      props: (route) => ({ user: JSON.parse(route.params?.user) }),
      meta: {
        requiresChangedPassword: true,
        title: "profile",
        requiresAuth: true,
      },
    },
    {
      path: "/timeoff/:type",
      name: "timeoff",
      component: () => import("./pages/timeoff.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Time Off",
        requiresAuth: true,
      },
    },
    {
      path: "/time&attendance/:type",
      name: "time&attendance",
      component: () => import("./pages/timeAndAttendance.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Time & Attendance",
        requiresAuth: true,
      },
    },

    {
      path: "/recruitment",
      name: "recruitment",
      component: () => import("./pages/recruitment.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "recruitment",
        requiresAuth: true,
      },
    },
    {
      path: "/benefits-setup/:type",
      name: "benefits-setups",
      component: () => import("./pages/companyBenefitSetups"),
      meta: {
        requiresChangedPassword: true,
        title: "Benefits Setup",
        requiresAuth: true,
      },
    },
    {
      path: "/core-setups/:type",
      name: "core-setups",
      component: () => import("./pages/companySetupsCore"),
      meta: {
        requiresChangedPassword: true,
        title: "Core Setup",
        requiresAuth: true,
      },
    },
    {
      path: "/separation-setups/:type",
      name: "separation-setups",
      component: () => import("./pages/companySeparationSetup"),
      meta: {
        requiresChangedPassword: true,
        title: "Core Setup",
        requiresAuth: true,
      },
    },
    {
      path: "/documents-setups/:type",
      name: "documents-setups",
      component: () => import("./pages/companyDocumentSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Documents Setups",
        requiresAuth: true,
      },
    },
    {
      path: "/assets-setups/:type",
      name: "assets-setups",
      component: () => import("./pages/companyAssetsSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Assets Setup",
        requiresAuth: true,
      },
    },
    {
      path: "/claims-setups/:type",
      name: "claims-setups",
      component: () => import("./pages/companyClaimsSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Claims Setup",
        requiresAuth: true,
      },
    },
    {
      path: "/timeoff-setups/:type",
      name: "timeoff-setups",
      component: () => import("./pages/companyTimeoffSetup.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Time Off Setup",
        requiresAuth: true,
      },
    },
    {
      path: "/performance-setup/:type",
      name: "performance-setups",
      component: () => import("./pages/companyPerformanceSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Performance Setup",
        requiresAuth: true,
      },
    },
    {
      path: "/company-setups/timeoff-setups/:type",
      name: "time-off-setups",
      component: () =>
        import("./components/CompanySetups/timeOffSetups/timeOffSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Time Off Setups",
        requiresAuth: true,
      },
      children: [],
    },

    {
      path: "/company-setups/claim-setups/:type",
      name: "claim-setups",
      component: () =>
        import("./components/CompanySetups/claimsSetups/claimSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Claim Setups",
        requiresAuth: true,
      },
    },
    {
      path: "/company-setups/:type",
      name: "company-setups",
      component: () => import("./pages/CompanySetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Company Setups",
        requiresAuth: true,
      },
    },

    {
      path: "/company-setups-core/:type",
      name: "company-setups-core",
      component: () => import("./pages/CompanySetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Company Setups Core",
        requiresAuth: true,
      },
    },
    {
      path: "/benefits-setups/:type",
      name: "benefits-setups",
      component: () => import("./pages/BenefitsSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Benefits Setups",
        requiresAuth: true,
      },
    },
    {
      path: "/documents-setups/:type",
      name: "documents-types",
      component: () => import("./pages/DocumentsSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Documents Setups",
        requiresAuth: true,
      },
    },

    {
      path: "/this-organization",
      name: "this-organization",
      component: () => import("./pages/thisOrganization.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "This Organization",
        requiresAuth: true,
      },
    },
    {
      path: "/announcements",
      name: "announcements",
      component: () => import("./pages/announcements.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Announcements",
        requiresAuth: true,
      },
    },
    {
      path: "/events",
      name: "events",
      component: () => import("./pages/events.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Events",
        requiresAuth: true,
      },
    },
    {
      path: "/reports/all",
      name: "reports",
      component: () => import("./pages/reports.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Reports",
        requiresAuth: true,
      },
    },
    {
      path: "/training/mine",
      name: "training",
      component: () => import("./pages/training.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Training",
        requiresAuth: true,
      },
    },
    {
      path: "/performancereview/MyPerformance",
      name: "PerformanceReview",
      component: () => import("./pages/PerformanceReview.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Performance Review",
        requiresAuth: true,
      },
    },
    {
      path: "/tasks/:type",
      name: "tasks",
      component: () => import("./pages/tasks.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Tasks",
        requiresAuth: true,
      },
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () => import("./pages/notifications.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Notifications",
        requiresAuth: true,
      },
    },
    {
      path: "*",
      name: "OrgNotFound",
      component: () => import("./pages/NotFound.vue"),
    },
  ],
  mode: "history",
  // make sure the the scroll postion is at the top position
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});


// if route requires authenication redirect to auth page
router.beforeEach((to, from, next) => {

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return;
    } else {
      next({
        name: "login",
        params: { company: store.getters.getOrganization, }
      });
      return;
    }
  } else {
    next();
    return;
  }
});


// Save the route name to the store
router.beforeEach((to, from, next) => {
  store.commit("saveRouteTo", to.name);
  next();
});

// Ensure all pending requests are canceled on route change
router.beforeEach((to, from, next) => {
  store.dispatch("cancelPendingRequests");
  next();
});


// silence Navigation Dupulicate error
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};



export default router;
